var React = require('react');

function WaveBigInverted (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1000 109L1000 0.705078C598.756 196.434 163.731 82.2594 0 0.705078V109H1000Z","fill":"current"}));
}

WaveBigInverted.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 1000 109","fill":"none","preserveAspectRatio":"none"};

module.exports = WaveBigInverted;

WaveBigInverted.default = WaveBigInverted;
